import { FC, useEffect } from 'react';
import CompetencyResultSample from '@components/common/competencyResultSample';
import ApplyResultSample from '@components/common/applyResultSample';
import { ResultMenuType } from '@components/acca/results/result/resultTab';
import { useMatchProfilesComplete } from '@repository/profiles/useProfile';
import { useGetMatchConfigStatus } from '@repository/match';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { useResultStore } from '@components/acca/results/result/resultStoreProvider';
import CompetencyType from './competencyType';
import NotOverYetBanner from './notOverYetBanner';
import CompetencyProfile from './competencyProfile';
import CompanyRecommend from './companyRecommend';
import JobRecommend from './jobRecommend';
import InterviewGuide from './interviewGuide';
import Share from './share';
import Feedback from './feedback';
import CopyrightWarning from './copyrightWarning';
import V3Result from '../applyResult/v3Result';
import { VersionType } from '@domain/constant/acca/VersionType';
import useCheckAuthority from '@utils/hooks/useCheckAuthority';

interface CompetencyResultProps {
  version?: VersionType | null;
  resultMenu: ResultMenuType;
}

const CompetencyResult: FC<CompetencyResultProps> = ({ version = 'V2', resultMenu }) => {
  const { data: userInfo } = useUserInfo();
  const isLogin = !!userInfo?.id;
  const { isAuthorityUser } = useCheckAuthority(userInfo);
  const { isPublicStore, accaResultStore } = useResultStore();
  const { data: ProfilesCompleteInfoData } = useMatchProfilesComplete();
  const { data: matchingConfig } = useGetMatchConfigStatus(isLogin);
  const { accResultSn, fetchAccCompetenceProfile, fetchAccCompetenceCurationCompany, fetchAccCompetenceCurationJob } =
    accaResultStore;

  useEffect(() => {
    initAccCompetency();
  }, [userInfo, accResultSn]);

  const initAccCompetency = () => {
    if (accResultSn === null) return;
    if (!isPublicStore && !isAuthorityUser) return;
    // @ts-ignore
    accaResultStore.fetchAccStatusUser?.();
    fetchAccCompetenceProfile();
    fetchAccCompetenceCurationCompany();
    fetchAccCompetenceCurationJob();
  };

  //제휴 서비스 가입한 대상자이거나 프로필 기본 완성시 and 추천 서비스 on일 경우 샘플 이미지 X
  if (
    version == 'V3' &&
    !isPublicStore &&
    !(isAuthorityUser || (ProfilesCompleteInfoData?.profileRequiredCompleteYn && matchingConfig?.matchingConfigYn))
  )
    return <ApplyResultSample resultMenu={resultMenu} version={version} />;

  if (version == 'V3') return <V3Result requestPage={'basic'} />;

  // 제휴서비스 신청 안 했을 경우
  if (!isPublicStore && !isAuthorityUser) return <CompetencyResultSample />;

  //V2 결과표
  return (
    <>
      {/* [D] 역량 유형 영역 */}
      <CompetencyType />

      {/* [D] 아직 끝이 아니에요 영역 */}
      <NotOverYetBanner />

      {/* [D] 역량 프로파일, 레이더 그래프 영역 */}
      <CompetencyProfile />

      {/* [D] 기업 추천, 바 그래프 영역 */}
      <CompanyRecommend />

      {/* [D] 직군, 직무 추천, 점그래프 영역 */}
      <JobRecommend />

      {/* [D] 면접 예상 질문 및 가이드 영역 */}
      <InterviewGuide />

      {/* [D] 공유하기 영역 */}
      <Share />

      {/* [D] 피드백 영역 */}
      <Feedback />

      {/* [D] 경고 영역 */}
      <CopyrightWarning />
    </>
  );
};

export default CompetencyResult;
